const logInfo = (...params: any) => {
  console.log(...params);
};

const logError = (...params: any) => {
  console.error(...params);
};

export { logInfo, logError };
